import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { FormProvider } from "react-hook-form";

import classNames from "classnames";

import BracketChangeModal from "./BracketChangeModal";
import ChildTournament from "./ChildTournament";
import MasterTouranment from "./MasterTournament";

import RegistrationButtons from "../RegistrationButtons";

import Loading from "../../../../../../components/Loading";
import { isChildTournament } from "../../../../../../lib/utils";
import { useTournamentContext } from "../../contexts/Tournament";
import { useFormHandlers } from "../../hooks/useFormHandlers";

const AdminView = (): React.JSX.Element => {
    const { isCreatingTournament, tournament, methods, fetchStatus } =
        useTournamentContext();

    const { onSubmit, onError } = useFormHandlers();
    const isMasterTournament = !isChildTournament(tournament);

    return (
        // FormProvider is needed for the FileUpload component
        <FormProvider {...methods}>
            <Form
                onSubmit={methods.handleSubmit(onSubmit, onError)}
                id="tournamentManagementTournamentInfoForm"
            >
                <Row>
                    {isMasterTournament ? (
                        <MasterTouranment />
                    ) : (
                        <ChildTournament />
                    )}
                </Row>
                <Row>
                    <RegistrationButtons />
                </Row>
                <Row>
                    <Col
                        className={classNames("d-flex", "align-items-baseline")}
                    >
                        <Button
                            variant="primary"
                            type="submit"
                            disabled={fetchStatus === "pending"}
                        >
                            {isCreatingTournament
                                ? "Add Tournament"
                                : "Update Tournament"}
                        </Button>
                        <Loading
                            className="mx-3 w-auto"
                            useContext={useTournamentContext}
                        />
                    </Col>
                </Row>
            </Form>
            <BracketChangeModal />
        </FormProvider>
    );
};

export default AdminView;
